"use client";
import * as React from "react";
const SvgCalendarSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14 1.46h-2.1V0h-1.4v1.46h-7V0H2.1v1.46H0V16h14zm-1.4 13.09H1.4V5.08h11.2z" }));
export {
  SvgCalendarSharp as default
};
